import React, { useContext } from "react";
import { Form, Checkbox } from "antd";
import { getFormItemLabel } from "../util/helpers";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import RestrictedContext from "../util/RestrictedContext";
import moment from "moment";

const ClosedPreviousOrderItem = (props) => {
  const { name, category, activeOrder, startDate } = props;
  const restricted = useContext(RestrictedContext);
  const intl = useIntl();
  const label = getFormItemLabel(intl, category, name, null);

  return (
    <Form.Item
      name={name}
      rules={[
        ({ getFieldValue }) => ({
          validator(_, value) {
            if (
              !value ||
              (value &&
                moment(startDate) >
                  moment(activeOrder.effective_from).endOf("day") &&
                (!activeOrder.effective_to ||
                  (activeOrder.effective_to &&
                    moment(startDate) <
                      moment(activeOrder.effective_to)
                        .add(1, "days")
                        .endOf("day"))))
            ) {
              return Promise.resolve();
            }
            return Promise.reject(
              new Error(
                intl.formatMessage({
                  id: "app.forms.order.wrong_range_of_duplicate_order",
                })
              )
            );
          },
        }),
      ]}
      valuePropName="checked"
      label={label}
    >
      <Checkbox disabled={!restricted["hasWritePermission"]}>{""}</Checkbox>
    </Form.Item>
  );
};

ClosedPreviousOrderItem.propTypes = {
  name: PropTypes.string,
  category: PropTypes.string,
};

export default ClosedPreviousOrderItem;
